"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SelectPharmacy = _interopRequireDefault(require("./SelectPharmacy"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _SelectPharmacy.default;
exports.default = _default;